export const deviceGroupScheduleConstants = {
    SCHEDULE_BY_ID_REQUEST: "SCHEDULE_BY_ID_REQUEST",
    SCHEDULE_BY_ID_SUCCESS: "SCHEDULE_BY_ID_SUCCESS",
    SCHEDULE_BY_ID_FAILURE: "SCHEDULE_BY_ID_FAILURE",
    SCHEDULE_BY_ID_CLEAR_STORE: "SCHEDULE_BY_ID_CLEAR_STORE",
};
